import { render, staticRenderFns } from "./LegalText.vue?vue&type=template&id=379678c5&scoped=true"
import script from "./LegalText.vue?vue&type=script&lang=js"
export * from "./LegalText.vue?vue&type=script&lang=js"
import style0 from "./LegalText.vue?vue&type=style&index=0&id=379678c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379678c5",
  null
  
)

export default component.exports